import clsx from "clsx";

export type CardVariant =
    | "success"
    | "error"
    | "warning"
    | "neutral"
    | "rag-red"
    | "rag-amber"
    | "rag-green";

export type CardProps = {
    variant?: CardVariant;
    children: React.ReactNode;
    className?: string;
};

const Card = ({ variant = "neutral", children, className }: CardProps) => {
    return (
        <div
            className={clsx(
                "rounded-xl",
                variant === "success" &&
                    "bg-deep-ocean-20 text-surface-light border-surface-light-5",
                variant === "error" && "bg-red-95 border-surface-dark-5",
                variant === "warning" && "bg-yellow-100 border-surface-dark-5",
                variant === "neutral" &&
                    "bg-surface-light-1 text-surface-dark-5 border-surface-dark-5",
                variant === "rag-red" && "border-2 border-red-40",
                variant === "rag-amber" && "border-2 border-rag-amber",
                variant === "rag-green" && "border-2 border-soft-green-80",
                className
            )}
        >
            {children}
        </div>
    );
};

export default Card;
